<template>
  <qx-custom-form
    :noSubBtn="true"
    ref="baseForm"
    :formData="baseForm"
    labelWidth="120px"
  >
    <span slot="oilBalanceTip">
      <OilAccount
        :balanceData="otherFormData"
        :driverOilForPayWay="driverOilForPayWay"
        @sub="setOilBalanceFromDialog"
        @getOilAccountType="getOilAccountType"
      />
    </span>
    <section slot="addOilCard">
      <AddOilCard v-model="otherFormData.oilcardList" />
    </section>
    <span slot="receiverUserNameTip" class="mode-btn-box">
      <BankAccount v-model="otherFormData.receiverUserInfo" />
    </span>
  </qx-custom-form>
</template>
<script>
import AddOilCard from './addOilCard/addOilCard';
import OilAccount from './oilAccount/oilAccount';
import BankAccount from 'components/bankAccount/bankAccount';
export default {
  props: {
    driverOilForPayWay: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AddOilCard,
    OilAccount,
    BankAccount,
  },
  data () {
    return {
      otherFormData: {
        oilcardList: [],
        // 油相关信息
        oilInfo: {},
        // 油卡充值前原始余额
        sPreOilBalance: '',
        // 油卡上一次重置的金额
        sBeforeBalance: 0,
        // 输入的充值金额
        sInputOilBalance: '',
        // 分配油来源
        oilAccountType: '1',
      },
      baseForm: {
        form: [
          {
            label: '空载油耗',
            value: 'emptyOilCostPer',
            type: 'input',
            unit: '（升/百公里）',
          },
          {
            label: '载重油耗',
            value: 'oilCostPer',
            type: 'input',
            unit: '（升/百公里）',
          },
          {
            label: '油账户余额',
            value: 'oilBalance',
            type: 'input',
            readonly: true,
          },
          {
            label: '添加油卡',
            value: 'addOilCard',
            allCustom: true,
          },
        ],
      },
    };
  },
  methods: {
    setCacheAndDetailData (data) {
      this.setFormValFromData(this.otherFormData, data);
    },
    // 分配油来源
    getOilAccountType (data) {
      this.otherFormData.oilAccountType = data;
    },
    // 从弹窗中获取油相关信息
    setOilBalanceFromDialog (data) {
      // 如果 sInputOilBalance 有值，则拼起来，没值，则直接使用接口返回的
      let oilBalance = `${this.otherFormData.sPreOilBalance}`;
      this.otherFormData.sInputOilBalance = data.sInputOilBalance || '';
      if (this.otherFormData.sInputOilBalance) {
        oilBalance += ` + ${this.otherFormData.sInputOilBalance}`;
      }
      this.$refs.baseForm.setVal('oilBalance', oilBalance);
      this.otherFormData.oilAccountType = data.oilAccountType;
    },
    // 设置空载和载重油耗
    setEmptyOilCostPerAndOilCostPer (options = {}) {
      this.$refs.baseForm.setVal('emptyOilCostPer', options.emptyOilCostPer || '0');
      this.$refs.baseForm.setVal('oilCostPer', options.oilCostPer || '0');
    },
    setOilBalance (oilBalance) {
      this.otherFormData.sPreOilBalance = oilBalance;
      if (this.otherFormData.sInputOilBalance) {
        this.$refs.baseForm.setVal('oilBalance', `${oilBalance} + ${this.otherFormData.sInputOilBalance}`);
      } else {
        this.$refs.baseForm.setVal('oilBalance', `${oilBalance}`);
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
